import React, { Component } from 'react';
import { withRouter } from 'react-router';
import Routes from 'Routes';
import Header from 'Header';
import { connect } from 'react-redux';
import './index.less';
import homeIcon from '../../assets/icon2-home.png';
// import homeIcon2 from '../../assets/home2.png';

class FeeQuery extends Component {
  _navBarLeftClick = () => {
    window.$sensors.sensors.track('fuction_click', {
      page_name: '机票退改说明页',
      fuction_area: '机票退改说明页-顶部导航栏',
      fuction_title: '机票退改说明页-顶部导航栏:返回',
    });
    this.props.router.goBack();
  };

  goHome = () => {
    window.$sensors.sensors.track('fuction_click', {
      page_name: '机票退改说明页',
      fuction_area: '机票退改说明页-顶部导航栏',
      fuction_title: '机票退改说明页-顶部导航栏:回到首页',
      target_url: 'https://m.csair.com',
    });
    window.location.href = 'https://m.csair.com';
  };

  render() {
    const {
      location: { query },
      lang,
    } = this.props;

    return (
      <div className="wrapper feeQueryList">
        <header>
          {/* <Header
            onLeftClick={this._navBarLeftClick}
            title={Routes.ticket.child.feeQuery.name}
          /> */}
          <Header
            onLeftClick={this._navBarLeftClick}
            rightContent={[
              <img
                alt=""
                key="1"
                src={homeIcon}
                onClick={this.goHome}
                style={{
                  width: '0.38rem',
                  height: '0.38rem',
                  marginRight: '0.2rem',
                }}
              />,
            ]}
            title={!query.channel ? lang.csair : lang.cancellationInt}
          />
        </header>
        {this.props.children}
      </div>
    );
  }
}

export default connect(
  state => ({
    lang: state.App.lang,
  }),
  dispatch => ({})
)(withRouter(FeeQuery));



// WEBPACK FOOTER //
// ./src/routes/routes/changeRefundExplain/components/FeeQueryContainer/index.js